import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FormGroup, Label, Input as InputReact } from 'reactstrap'
import { Select, Input, message, Spin } from 'antd'
import getHistory from '../../../getHistory'
import { getListShippingCarrierApp } from '../../../services/api/apiFFM'
import { getCombineShipDetails, createCombineShip, updateCombineShip } from '../../../services/api/apiCombineShip'
import { getBarcodeByNumber } from '../../../services/api/apiBarcode'
import { ReactComponent as IconDelete } from "../../../assets/icon/icon-delete.svg"
import { useHistory } from 'react-router-dom'

const { Option } = Select

function CombineShipCreatePageContainer(props) {
    const combineShipId = props.match.params.id
    const {state: stateOrders = {}} = useLocation()
    const { orders = [] } = stateOrders

    const [itemType, setItemType] = useState('normal')
    const [status, setStatus] = useState('')
    const [error, setError] = useState('')
    const [searchValue, setSearchValue] = useState('')
    const [OrderNumber, setOrderNumber] = useState('')
    const [batchShip, setBatchShip] = useState({})
    const [size, _setSize] = useState([])
    const [loading, setLoading] = useState(false)
    // const [errors, setErrors] = useState([])
    const [firtItem, setFirstItem] = useState(orders[0] || '')
    const [barcodes, setBarcodes] = useState(orders || [])
    const [listShippingCarrier, setListShippingCarrier] = useState([])
    const [allShippingCarrier, setAllShippingCarrier] = useState([])
    const [lineShip, setLineShip] = useState('')
    const [name, setName] = useState('')
    const [country, setCountry] = useState('')
    const [address1, setAddress1] = useState('')
    const [address2, setAddress2] = useState('')
    const [email, setEmail] = useState('')
    const [postalCode, setPostalCode] = useState('')
    const [city, setCity] = useState('')
    const [phone, setPhone] = useState('')
    const [state, setState] = useState('')
    const [weight, setWeight] = useState('')
    const [length, setLength] = useState('')
    const [width, setWidth] = useState('')
    const [height, setHeight] = useState('')
    const [errValidate, setErrValidate] = useState({})
    const [combineShipDetail, setCombineShipDetail] = useState({})
    const [loadingCreate, setLoadingCreate] = useState(false)
    const [loadingUpdate, setLoadingUpdate] = useState(false)

    const [listBoxes, setListBoxes] = useState([
        {
            weight: 0,
            length: size.length ? size[0] : 0,
            width: size.length ? size[1] : 0,
            height: size.length ? size[2] : 0,
            barcodes: []
        }
    ])
    const [boxQuantity, setBoxQuantity] = useState(null)
    const [boxIndex, setBoxIndex] = useState(0)
    const [searchValueBox, setSearchValueBox] = useState('')
    const history = useHistory()

    useEffect(() => {
        // Lấy data từ localStorage và truyền vào state
        const raw = localStorage.getItem('combineShipOrders')
        const ordersLocal = raw ? JSON.parse(raw) : []
        history.replace({ pathname: history.location.pathname, state: { orders: ordersLocal } })
        // Xóa data trong localStorage
        localStorage.removeItem('combineShipOrders')
    }, [history])

    useEffect(() => {
        // Cập nhật lại khi state orders thay đổi
        setBarcodes(orders)
        setFirstItem(orders[0] || '')
    }, [orders])

    const getInfoByOrderNumberFirst = async () => {
        setLoading(true)
        try {
            const { data: Data } = await getBarcodeByNumber(firtItem)
            const { message: mess, success, data } = Data
            // const { batch, boxes, errors } = { ...data }

            if (success) {
                setName(data.name)
                setAddress1(data.address1 || '')
                setAddress2(data.address2 || '')
                setCountry(data.country || '')
                setPostalCode(data.postalCode || '')
                setEmail(data.email || '')
                setCity(data.city || '')
                setPhone(data.phone || '')
                setState(data.state || '')
            } else {
                message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const fetchCombineShipDetails = async (id) => {
        setLoading(true)
        try {
            const { data: Data = {} } = await getCombineShipDetails(id)
            const { message: mess, success, data } = { ...Data }
            if (!success) {
                throw new Error(mess)
            }
            const { meta = {} } = Object.assign({}, data)
            const { boxes = [] } = Object.assign({}, meta)
            setCombineShipDetail(data)
            setBatchShip(data.batch_ship || {})
            setOrderNumber(data.id)
            setItemType(data.type)
            setBarcodes(data.barcodes)
            setLineShip(data.line_ship)
            setStatus(data.status)
            setName(data.address.name || '')
            setAddress1(data.address.address1 || '')
            setAddress2(data.address.address2 || '')
            setCity(data.address.city || '')
            setState(data.address.state || '')
            setCountry(data.address.country || '')
            setPostalCode(data.address.postal_code || '')
            setEmail(data.address.email || '')
            setPhone(data.address.phone || '')
            setLength(data.dimension && data.dimension.length ? data.dimension.length : '')
            setWeight(data.dimension && data.dimension.weight ? data.dimension.weight : '')
            setWidth(data.dimension && data.dimension.width ? data.dimension.width : '')
            setHeight(data.dimension && data.dimension.height ? data.dimension.height : '')
            if (!!boxes.length) setListBoxes(boxes)
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }

    }

    const fetchFiltersShippingCarrier = async(payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrierApp(newPayload)
            const {data, success, message} = {...res}
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length > 0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            setListShippingCarrier(shippingCarriers.filter(i => !!i.is_active) || [])
            setAllShippingCarrier(shippingCarriers || [])
            
        } catch (error) {
            alert(error.message)
        }
    }

    useEffect(() => {
        fetchFiltersShippingCarrier()
        !!combineShipId && fetchCombineShipDetails(combineShipId)
    }, [])

    useEffect(() => {
        !combineShipId && !!firtItem && getInfoByOrderNumberFirst()
    }, [firtItem])

    const validate = () => {
        setErrValidate({})

        let err = {}

        if(!combineShipId && barcodes.length < 2){
            err.barcodes = 'Cần tối thiểu 2 barcode để gộp ship.'
        }else if(!!combineShipId && barcodes.length === 1){
            err.barcodes = 'Cần tối thiểu 2 barcode để gộp ship.'
        }

        if (!lineShip) err.lineShip = 'Chọn line ship.'

        if (Object.keys(err).length > 0) {
            setErrValidate(err)
            return false
        } else {
            return true
        }
    }

    const handleSave = () => {
        if (!validate()) return
        setError('')
        if (!!combineShipId) {
            handleUpdateCombineShip()

        } else {
            handleCreateCombineShip()
        }
    }

    const handleCreateCombineShip = async () => {
        setLoadingCreate(true)
        const address = {
            name,
            address1,
            address2,
            city,
            state,
            country,
            postal_code: postalCode,
            email,
            phone
        }
        const dimension = {
            weight: +weight,
            length: +length,
            width: +width,
            height: +height
        }
        const payload = {
            barcodes: barcodes.map(barcode => +barcode),
            type: itemType,
            line_ship: lineShip,
            address,
            dimension
        }

        try {
            const { data: Data } = await createCombineShip(payload)
            const { success, message: mess } = Data
            if (success) {
                message.success('Đơn gộp ship đã được tạo!')
                const history = getHistory()
                history.push(`/combine-ship`)
            } else {
                message.error(mess)
                setError(mess)
            }
        } catch (error) {
            message.error(error.message)
        }finally{
            setLoadingCreate(false)
        }
    }

    const handleUpdateCombineShip = async () => {
        setLoadingUpdate(true)
        const address = {
            name,
            address1,
            address2,
            city,
            state,
            country,
            postal_code: postalCode,
            email,
            phone
        }

        const dimension = {
            weight: +weight,
            length: +length,
            width: +width,
            height: +height
        }

        const payload = {
            barcodes: barcodes.map(barcode => +barcode),
            type: itemType,
            line_ship: lineShip,
            address,
            dimension
        }

        let meta = {}
        if(!!listBoxes.length && itemType === 'fast') meta.boxes = listBoxes
        if(!!Object.keys(meta).length) payload.meta = meta

        try {
            const { data: Data } = await updateCombineShip(combineShipId, payload)
            const { success, message: mess, } = Data
            if (success) {
                message.success('Đơn gộp ship đã được update!')
                const history = getHistory()
                history.push(`/combine-ship`)
            } else {
                message.error(mess)
                setError(mess)
            }
        } catch (error) {
            message.error(error.message)
        }finally{
            setLoadingUpdate(false)
        }

    }

    const _handleChangeItemtype = (value) => {
        if(value === 'fast'){
            setLineShip('SB_FAST')
            setLength('')
            setWeight('')
            setWidth('')
            setHeight('')
        }else{
            setLineShip('')
        }
        setItemType(value)
    }

    const handleSearch = (value) => {
        // setError('')
        if (value.includes(',') || value.includes(' ')) {
            setSearchValue('')
            const Value = [...new Set(value.replace(/ |#|'|_\d+/g, ",").split(',').map(i => i.trim()).filter(i => !!i && !barcodes.includes(i) && i))]
            
            const newListItems = [...barcodes, ...Value]
            if(newListItems[0] !== firtItem){
                setFirstItem(newListItems[0])
            }
            setBarcodes(newListItems)
        } else {
            setSearchValue(value)
        }
    }

    const handleChangeInput = (field, value) => {
        delete errValidate[field]
        if(field === 'barcodes'){
            setBarcodes(value)
            if(value[0] !== firtItem){
                setFirstItem(value[0])
            }
            setSearchValue('')
        }else if(field === 'lineShip'){
            setLineShip(value)
        }else if(field === 'name'){
            setName(value)
        }else if(field === 'country'){
            setCountry(value)
        }else if(field === 'address1'){
            setAddress1(value)
        }else if(field === 'address2'){
            setAddress2(value)
        }else if(field === 'postalCode'){
            setPostalCode(value)
        }else if(field === 'email'){
            setEmail(value)
        }else if(field === 'city'){
            setCity(value)
        }else if(field === 'phone'){
            setPhone(value)
        }else if(field === 'state'){
            setState(value)
        }else if(field === 'weight'){
            setWeight(value)
        }else if(field === 'length'){
            setLength(value)
        }else if(field === 'width'){
            setWidth(value)
        }else if(field === 'height'){
            setHeight(value)
        }
    }

    const shippingCarrierOptions = !!listShippingCarrier && listShippingCarrier.length > 0 ? itemType === 'normal' ? listShippingCarrier.map(i=> ({
        value: i.slug,
        name: i.name,
        is_active: i.is_active,
    })).filter(item => item.name !== 'SB_FAST') : listShippingCarrier.map(i=> ({
        value: i.slug,
        name: i.name,
        is_active: i.is_active,
    })) : []

    const _handleAddNewBoxes = (isMoreBox = false) => {
        if(!isMoreBox) {
            setListBoxes([
                ...listBoxes,
                {
                    weight: 0,
                    length: size.length ? size[0] : 0,
                    width: size.length ? size[1] : 0,
                    height: size.length ? size[2] : 0,
                    barcodes: []
                }
            ])
        }else{
            let listBoxNew = []
            for(let i = 0; i < boxQuantity; i++){
                listBoxNew.push({
                    weight: 0,
                    length: size.length ? size[0] : 0,
                    width: size.length ? size[1] : 0,
                    height: size.length ? size[2] : 0,
                    barcodes: []
                })
            }
            setListBoxes([
                ...listBoxes,
                ...listBoxNew
            ])
            setBoxQuantity()
        }
    }

    const _handleChangeBoxesState = (index, field, value) => {

        setError('')

        if (field === 'barcodes') {
            setSearchValueBox('')
        }

        let listBoxesUpdated = []

        listBoxes.map((i, idx) => {
            if (idx === index) {
                if (field === 'barcodes') {
                    return listBoxesUpdated.push({ ...i, ['barcodes']: [... new Set(value.filter(i => !!i && i).map(i => i.replace(/#|'|_\d+/g, "")))] })
                }
                return listBoxesUpdated.push({ ...i, [field]: value })
            }

            return listBoxesUpdated.push(i)
        })

        setListBoxes(listBoxesUpdated)
    }

    const _handleRemoveBoxes = (index) => {
        setError('')
        const listBoxesUpdated = listBoxes.filter((i, idx) => idx !== index)
        setListBoxes(listBoxesUpdated)
    }

    const handleSearchBox = (index, value) => {
        setBoxIndex(index)
        setError('')
        if (value.includes(',') || value.includes(' ')) {
            setSearchValueBox('')
            const Value = [...new Set(value.replace(/ |#|'|_\d+/g, ",").split(',').map(i => i.trim()).filter(i => !!i && !listBoxes[index].barcodes.includes(i) && i))]

            let listBoxesUpdated = []
            listBoxes.map((i, idx) => {
                if (idx === index && Value.length > 0) {
                    return listBoxesUpdated.push({ ...i, ['barcodes']: [...i.barcodes, ...Value] })
                }
                return listBoxesUpdated.push(i)
            })
            setListBoxes(listBoxesUpdated)
        } else {
            setSearchValueBox(value)
        }
    }

    const Title = !!combineShipId ? `Sửa đơn gộp ship ${OrderNumber}` : 'Thêm đơn gộp ship mới'
    const { tags = [], line_ship } = { ...combineShipDetail }

    return (
        <div className='BatchShipCreatePageContainer'>
            <div className='d-flex align-items-center justify-content-between'>
                <div className="ReturnPage mb-2">
                    <Link to={'/combine-ship'} className="txt-16">
                        <i className="fa fa-chevron-left mr-1" /> Danh sách đơn gộp ship
                    </Link>
                </div>

                {
                    !!combineShipId && itemType === 'fast' && !['cancelled', 'in_production'].includes(status) &&
                    <div className="RedirectPage mb-2">
                        <Link to={`/batch-ship/${batchShip._id}`} className="txt-16">
                            <i className="fa fa-chevron-left mr-1" /> Lô ship đơn {batchShip.id}
                        </Link>
                    </div>
                }
                
            </div>
            
            <div className='FileDetailPage'>
                <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                    <h1 className="PageTitle font-weight-bold mb-0">{!loading && Title}</h1>
                    <div className="RightTop">
                        <div className='Actions mb-2'>
                            <Link to={'/combine-ship'}>
                                <button
                                    className='btn btn-secondary mx-1'
                                    style={{ background: '#C4C4C4' }}
                                >
                                    Huỷ
                                </button>
                            </Link>
                            <button
                                className='btn btn-primary mx-1'
                                style={{ background: '#4A80F7' }}
                                onClick={handleSave}
                                disabled={loading || loadingCreate || loadingUpdate}
                            >
                                Lưu
                            </button>
                        </div>
                    </div>
                </div>
                <Spin spinning={loading} tip='Data Loading...'>
                    <div className="SectionInner card px-4 py-4 mt-3" style={{ minHeight: '730px' }}>
                        <h6 className='font-weight-bold txt-14'>CHỌN ĐƠN GỘP SHIP</h6>
                        <div className='d-flex align-items-center'>
                            <FormGroup check className='mr-3 mb-0'>
                                <Label check className='txt-14'>
                                    <InputReact type="radio" name="normal"
                                        checked={itemType === 'normal'}
                                        disabled={!!combineShipId && itemType !== 'normal'}
                                        onChange={({ target: { name } }) => _handleChangeItemtype(name)}
                                    /> Ship thường
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check className='txt-14'>
                                    <InputReact type="radio" name="fast"
                                        checked={itemType === 'fast'}
                                        disabled={!!combineShipId && itemType !== 'fast'}
                                        onChange={({ target: { name } }) => _handleChangeItemtype(name)}
                                    /> Ship nhanh
                                </Label> 
                            </FormGroup>
                        </div>
                        <div className=" mt-4 align-items-center">
                            <h6 className='font-weight-bold mb-2 txt-14'>THÔNG TIN ĐƠN GỘP SHIP</h6>
                            <div className='align-items-start '>
                                <table>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Các đơn gộp ship</th>
                                            <th>Line ship</th>
                                            <th>Địa chỉ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='pr-3 align-items-center txt-14'></td>
                                            <td className='py-2 pr-4 Box' style={{verticalAlign: 'top'}}>
                                                <Select
                                                    mode={'tags'}
                                                    className='Boxes'
                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                    onChange={(value) => handleChangeInput('barcodes', value)}
                                                    style={{ width: '600px', maxWidth:'600px' }}
                                                    value={barcodes || []}
                                                    onSearch={(value) => handleSearch(value)}
                                                    searchValue={searchValue}
                                                    virtual={false}
                                                    open={false}
                                                    allowClear
                                                />

                                                {errValidate['barcodes'] &&
                                                    <div className='text-danger mt-1'>{errValidate['barcodes']}</div>
                                                }
                                            </td>
                                            <td className='py-2 pr-4 Weight' style={{verticalAlign: 'top'}} >
                                                <Select
                                                    style={{ minWidth: "200px" }}
                                                    placeholder=""
                                                    value={lineShip || []}
                                                    onChange={(value) => handleChangeInput('lineShip', value)}
                                                    allowClear
                                                    disabled={loading || itemType === 'fast' || (!!combineShipId && (status === 'confirmed' || status === 'completed'))}
                                                    showSearch
                                                    onSearch={(value) => {
                                                        if (value) {
                                                            const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase()))
                                                            setListShippingCarrier(newList)
                                                        } else { setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active)) }
                                                    }}
                                                    onBlur={() => setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active))}
                                                    filterOption={(input, option) => {
                                                        return option.children.toLowerCase().includes(input.toLowerCase())
                                                    }}
                                                >
                                                    {!!shippingCarrierOptions.length && shippingCarrierOptions.map((i, index) => (
                                                        <Option value={i.value} key={index} style={!i.is_active ? {} : { color: '#333' }}>{i.name}</Option>
                                                    ))}
                                                    <Option value={'other'} key={'other'}>Other</Option>
                                                </Select>

                                                {errValidate['lineShip'] &&
                                                    <div className='text-danger mt-1'>{errValidate['lineShip']}</div>
                                                }
                                            </td>
                                            <td className='py-2 pr-2 Size' style={{verticalAlign: 'top'}}>
                                                <div className='container'>
                                                    <div className='row'>
                                                        <div className='col-6 col-md-6'>
                                                            <div className='field-input'>
                                                                <label className='d-block'>Name</label>
                                                                <Input
                                                                    value={name || ''}
                                                                    type='text'
                                                                    className='Name'
                                                                    placeholder=''
                                                                    // allowClear
                                                                    onChange={(e) => handleChangeInput('name', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>
                                                            
                                                            <div className='field-input mt-2'>
                                                                <label className='d-block'>Address1</label>
                                                                <Input
                                                                    value={address1 || ''}
                                                                    type='text'
                                                                    className='Address1'
                                                                    placeholder=''
                                                                    allowClear
                                                                    onChange={(e) => handleChangeInput('address1', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>

                                                            <div className='field-input mt-2'>
                                                                <label className='d-block'>Address2</label>
                                                                <Input
                                                                    value={address2 || ''}
                                                                    type='text'
                                                                    className='Address2'
                                                                    placeholder=''
                                                                    allowClear
                                                                    onChange={(e) => handleChangeInput('address2', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>

                                                            <div className='field-input mt-2'>
                                                                <label className='d-block'>City</label>
                                                                <Input
                                                                    value={city || ''}
                                                                    type='text'
                                                                    className='City'
                                                                    placeholder=''
                                                                    allowClear
                                                                    onChange={(e) => handleChangeInput('city', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>

                                                            <div className='field-input mt-2'>
                                                                <label className='d-block'>State</label>
                                                                <Input
                                                                    value={state || ''}
                                                                    type='text'
                                                                    className='State'
                                                                    placeholder=''
                                                                    allowClear
                                                                    onChange={(e) => handleChangeInput('state', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='col-6 col-md-6'>
                                                            <div className='field-input'>
                                                                <label className='d-block'>Country</label>
                                                                <Input
                                                                    value={country || ''}
                                                                    type='text'
                                                                    className='Country'
                                                                    placeholder=''
                                                                    allowClear
                                                                    onChange={(e) => handleChangeInput('country', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>

                                                            <div className='field-input mt-2'>
                                                                <label className='d-block'>Postal Code</label>
                                                                <Input
                                                                    value={postalCode || ''}
                                                                    type='text'
                                                                    className='PostalCode'
                                                                    placeholder=''
                                                                    allowClear
                                                                    onChange={(e) => handleChangeInput('postalCode', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>

                                                            <div className='field-input mt-2'>
                                                                <label className='d-block'>Email</label>
                                                                <Input
                                                                    value={email || ''}
                                                                    type='text'
                                                                    className='Email'
                                                                    placeholder=''
                                                                    allowClear
                                                                    onChange={(e) => handleChangeInput('email', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>

                                                            <div className='field-input mt-2'>
                                                                <label className='d-block'>Phone</label>
                                                                <Input
                                                                    value={phone || ''}
                                                                    type='text'
                                                                    className='Phone'
                                                                    placeholder=''
                                                                    allowClear
                                                                    onChange={(e) => handleChangeInput('phone', e.target.value)}
                                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                {
                                    itemType === 'fast' ?
                                        !!combineShipId &&
                                        <div className="align-items-center mt-2">
                                            <h6 className='font-weight-bold mb-2 txt-14'>THÔNG TIN LÔ THÙNG</h6>
                                            <div className='align-items-start '>
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>
                                                                <div className="d-flex justify-content-between">
                                                                    <span>Đơn trong thùng ship</span>
                                                                    <div className="d-flex align-items-baseline pr-4">
                                                                        <label style={{ whiteSpace: 'nowrap', marginRight: '15px' }}>Số thùng</label>
                                                                        <Input
                                                                            value={boxQuantity || ''}
                                                                            type='number'
                                                                            placeholder='Nhập số thùng'
                                                                            allowClear
                                                                            disabled={(status === 'confirmed' || status === 'completed')}
                                                                            onChange={(e) => setBoxQuantity(e.target.value)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === "Enter") {
                                                                                    e.preventDefault()
                                                                                    _handleAddNewBoxes(true)
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <th>Cân nặng</th>
                                                            <th className=''>
                                                                Kích thước
                                                            </th>
                                                            <th className='box-action'></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!!listBoxes.length && listBoxes.map((i, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td className='pr-3 align-items-center txt-14'>
                                                                        Thùng {index + 1}
                                                                    </td>
                                                                    <td className='py-2 pr-4 align-items-center Box'>
                                                                        <Select
                                                                            mode={'tags'}
                                                                            className='Boxes'
                                                                            onChange={(value) => _handleChangeBoxesState(index, 'barcodes', value)}
                                                                            style={{ minWidth: '600px' }}
                                                                            value={[...i.barcodes] || []}
                                                                            onSearch={(value) => handleSearchBox(index, value)}
                                                                            searchValue={boxIndex === index ? searchValueBox : ''}
                                                                            virtual={false}
                                                                            open={false}
                                                                            allowClear
                                                                            disabled={(status === 'confirmed' || status === 'completed')}
                                                                        />
                                                                    </td>
                                                                    <td className='pr-4 align-items-center Weight'>
                                                                        <Input
                                                                            value={i.weight || ''}
                                                                            type='number'
                                                                            placeholder='weight'
                                                                            allowClear
                                                                            addonAfter="kg"
                                                                            disabled={(status === 'confirmed' || status === 'completed')}
                                                                            onChange={({ target: { value } }) => _handleChangeBoxesState(index, 'weight', +value)}
                                                                        />
                                                                    </td>
                                                                    <td className='pr-2 align-items-center Size'>
                                                                        <div className='d-flex align-items-center'>
                                                                            <Input
                                                                                value={i.length || ''}
                                                                                type='number'
                                                                                className='Length'
                                                                                placeholder='length'
                                                                                allowClear
                                                                                addonAfter="cm"
                                                                                disabled={(status === 'confirmed' || status === 'completed')}
                                                                                onChange={({ target: { value } }) => _handleChangeBoxesState(index, 'length', +value)}
                                                                            /> x
                                                                            <Input
                                                                                value={i.width || ''}
                                                                                type='number'
                                                                                className='Width'
                                                                                placeholder='width'
                                                                                allowClear
                                                                                addonAfter="cm"
                                                                                disabled={(status === 'confirmed' || status === 'completed')}
                                                                                onChange={({ target: { value } }) => _handleChangeBoxesState(index, 'width', +value)}
                                                                            /> x
                                                                            <Input
                                                                                value={i.height || ''}
                                                                                type='number'
                                                                                className='Height'
                                                                                placeholder='height'
                                                                                allowClear
                                                                                addonAfter="cm"
                                                                                disabled={(status === 'confirmed' || status === 'completed')}
                                                                                onChange={({ target: { value } }) => _handleChangeBoxesState(index, 'height', +value)}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    {
                                                                        listBoxes.length > 1 && !(status === 'confirmed' || status === 'completed') && 
                                                                        <td>
                                                                            <IconDelete className='cursor-pointer' onClick={() => _handleRemoveBoxes(index)} />
                                                                        </td>
                                                                    }
                                                                </tr>
                                                            )
                                                        }
                                                        )}
                                                        {!(line_ship === 'SB_FAST' && tags.includes('combo_fac')) &&
                                                            <tr>
                                                                <td colSpan={4}>
                                                                    <div className='w-100 pr-2'>
                                                                        <button
                                                                            className='btn btn-primary mt-3 float-right'
                                                                            style={{ background: '#4A80F7' }}
                                                                            onClick={() => _handleAddNewBoxes()}
                                                                            disabled={(status === 'confirmed' || status === 'completed')}
                                                                        >
                                                                            Thêm thùng ship
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                                {/* {!!errors && status === 'open' &&
                                                    errors.map(i =>
                                                    (<label
                                                        className={(i.type === 'error' ? 'text-danger' : 'text-warning') + ' w-100 mt-1'}
                                                        style={{ whiteSpace: "pre-line" }}
                                                    >
                                                        <i className={i.type === 'error' ? 'icon-cancel-circle2' : 'icon-warning22'} /> {i.msg}
                                                    </label>)
                                                    )
                                                } */}
                                                {!!error && (status === 'open' || status === '') &&
                                                    <label className='text-danger mt-3' style={{ whiteSpace: "pre-line" }}>{error}</label >
                                                }
                                            </div>
                                        </div> :
                                        <div className="info-combine-ship mt-2">
                                            <div className='field-input'>
                                                <label className='d-block font-weight-bold'>Cân nặng đơn gộp ship</label>
                                                <Input
                                                    value={weight || ''}
                                                    type='number'
                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                    placeholder='weight'
                                                    allowClear
                                                    addonAfter="kg"
                                                    onChange={(e) => handleChangeInput('weight', e.target.value)}
                                                    style={{ width: '300px' }}
                                                />
                                            </div>

                                            <div className='field-input mt-2'>
                                                <label className='d-block font-weight-bold'>Kích thước đơn gộp ship</label>
                                                <Input
                                                    value={length || ''}
                                                    type='number'
                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                    placeholder='length'
                                                    allowClear
                                                    addonAfter="cm"
                                                    onChange={(e) => handleChangeInput('length', e.target.value)}
                                                    style={{ width: '300px' }}
                                                />
                                            </div>

                                            <div className='field-input mt-2'>
                                                <Input
                                                    value={width || ''}
                                                    type='number'
                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                    placeholder='width'
                                                    allowClear
                                                    addonAfter="cm"
                                                    onChange={(e) => handleChangeInput('width', e.target.value)}
                                                    style={{ width: '300px' }}
                                                />
                                            </div>

                                            <div className='field-input mt-2'>
                                                <Input
                                                    value={height || ''}
                                                    type='number'
                                                    disabled={!!combineShipId && (status === 'confirmed' || status === 'completed')}
                                                    placeholder='height'
                                                    allowClear
                                                    addonAfter="cm"
                                                    onChange={(e) => handleChangeInput('height', e.target.value)}
                                                    style={{ width: '300px' }}
                                                />
                                            </div>
                                        </div>
                                }

                                {/* {!!errors && status === 'open' &&
                                    errors.map(i =>
                                    (<label
                                        className={(i.type === 'error' ? 'text-danger' : 'text-warning') + ' w-100 mt-1'}
                                        style={{ whiteSpace: "pre-line" }}
                                    >
                                        <i className={i.type === 'error' ? 'icon-cancel-circle2' : 'icon-warning22'} /> {i.msg}
                                    </label>)
                                    )
                                }
                                {!!error && (status === 'open' || status === '') &&
                                    <label className='text-danger mt-3' style={{ whiteSpace: "pre-line" }}>{error}</label >
                                } */}
                            </div>
                        </div>
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export default CombineShipCreatePageContainer